export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14369.02052b7f.jpg";